import { NotificationPopover } from "./NotificationPopover";

export const Notifications = () => <NotificationPopover />;
